/* ==========================================================================
   FORME — global.js
   Drawers, announcement rotation, quick add (AJAX), cart drawer refresh,
   swatch-driven card image swap, product variant picker, collection toolbar.
   ========================================================================== */

(function () {
  'use strict';

  var overlay = document.querySelector('[data-overlay]');
  var openDrawer = null;

  /* ---------------------------------------------------------------- utils */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function toast(message) {
    var el = qs('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* -------------------------------------------------------------- drawers */

  function setDrawer(drawer, open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      if (openDrawer && openDrawer !== drawer) setDrawer(openDrawer, false);
      openDrawer = drawer;
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
      document.body.style.overflow = 'hidden';
      var focusable = drawer.querySelector('button, a, input, select');
      if (focusable) focusable.focus({ preventScroll: true });
    } else {
      if (openDrawer === drawer) openDrawer = null;
      if (!openDrawer && overlay) {
        overlay.classList.remove('is-visible');
        setTimeout(function () { if (!openDrawer) overlay.hidden = true; }, 300);
      }
      if (!openDrawer) document.body.style.overflow = '';
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      setDrawer(qs(opener.getAttribute('data-drawer-open')), true);
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      setDrawer(closer.closest('.drawer'), false);
    }
  });

  if (overlay) overlay.addEventListener('click', function () { setDrawer(openDrawer, false); toggleSearch(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(openDrawer, false); toggleSearch(false); }
  });

  /* --------------------------------------------------------------- search */

  function toggleSearch(open) {
    var panel = qs('[data-search-overlay]');
    if (!panel) return;
    var shouldOpen = typeof open === 'boolean' ? open : !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', shouldOpen);
    if (shouldOpen) {
      var input = panel.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 200);
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); toggleSearch(); }
  });

  /* --------------------------------------------------- announcement rotate */

  qsa('[data-announcement]').forEach(function (bar) {
    var items = qsa('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 4500);
  });

  /* --------------------------------------------------------- cart helpers */

  function refreshCart(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var fresh = holder.querySelector('#CartDrawer');
        var current = qs('#CartDrawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
        return fetch(window.routes.cart_url + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            qsa('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.setAttribute('data-count', cart.item_count);
            });
            if (openAfter) setDrawer(qs('#CartDrawer'), true);
          });
      })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  /* ------------------------------------------------------------ quick add */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-quick-add');
      trigger.disabled = true;
      addToCart(id)
        .then(function () { toast('Added to bag'); return refreshCart(true); })
        .catch(function (err) { toast(err && err.description ? err.description : 'Could not add to bag'); })
        .finally(function () { trigger.disabled = false; });
      return;
    }

    var expander = e.target.closest('[data-quick-expand]');
    if (expander) {
      e.preventDefault();
      var card = expander.closest('.card');
      var options = card && card.querySelector('[data-quick-options]');
      if (options) { options.hidden = false; expander.hidden = true; }
    }
  });

  /* --------------------------------------------------- cart line quantity */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var line = btn.closest('[data-line-key]');
    if (!line) return;
    var input = line.querySelector('[data-qty-input]');
    var next = Math.max(0, parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10));
    changeLine(line.getAttribute('data-line-key'), next);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    var line = btn.closest('[data-line-key]');
    if (line) changeLine(line.getAttribute('data-line-key'), 0);
  });

  function changeLine(key, quantity) {
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); }
        else { refreshCart(false); }
      })
      .catch(function () { toast('Could not update bag'); });
  }

  /* ------------------------------------------- swatch → card image swap */

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;
    e.preventDefault();

    var card = swatch.closest('.card');
    if (!card) return;

    qsa('[data-swatch]', card).forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');

    var img = card.querySelector('.card__img--primary');
    var src = swatch.getAttribute('data-image');
    if (img && src) {
      img.src = src;
      img.removeAttribute('srcset');
    }

    var url = swatch.getAttribute('data-url');
    var link = card.querySelector('.card__media-wrap');
    var titleLink = card.querySelector('.card__title a');
    if (url) {
      if (link) link.setAttribute('href', url);
      if (titleLink) titleLink.setAttribute('href', url);
    }
  });

  /* ------------------------------------------------- product form picker */

  qsa('[data-product-form]').forEach(function (root) {
    var json = qs('[data-product-json]', root);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = qs('[data-variant-id]', root);
    var priceEl = qs('[data-price]', root);
    var buyBtn = qs('[data-buy-button]', root);

    function selectedOptions() {
      return qsa('fieldset', root).map(function (set) {
        var checked = set.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function money(cents) {
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    }

    function sync() {
      var opts = selectedOptions();
      var match = product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });

      if (match) {
        idInput.value = match.id;
        if (priceEl) {
          priceEl.innerHTML = match.compare_at_price > match.price
            ? money(match.price) + ' <s>' + money(match.compare_at_price) + '</s>'
            : money(match.price);
        }
        if (buyBtn) {
          buyBtn.disabled = !match.available;
          buyBtn.textContent = match.available ? buyBtn.getAttribute('data-label-add') : 'Sold out';
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } else if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.textContent = 'Unavailable';
      }
    }

    root.addEventListener('change', sync);
    sync();
  });

  /* ---------------------------------------------------- collection tools */

  qsa('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  qsa('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      form.submit();
    });
  });

  /* ------------------------------------------------------- initial count */

  fetch(window.routes.cart_url + '.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
    })
    .catch(function () {});
})();
